document.addEventListener('DOMContentLoaded', function() {
  // Dev mode detection - only log in development
  const isDevMode = window.location.hostname === '127.0.0.1' || 
                    window.location.hostname === 'localhost' ||
                    window.location.port === '9292' ||
                    window.location.href.includes('127.0.0.1:9292') ||
                    window.location.hostname.startsWith('192.168.');

  const postcodeInputs = document.querySelectorAll('.postcode-input');
  const postcodeStatuses = document.querySelectorAll('.postcode-status');
  const postcodeReference = document.querySelectorAll('.postcode-reference');

  const ukBankHolidays = [
    // 2025
    "2025-01-01", // New Year's Day
    "2025-04-18", // Good Friday
    "2025-04-21", // Easter Monday
    "2025-05-05", // Early May Bank Holiday
    "2025-05-26", // Spring Bank Holiday
    "2025-08-25", // Summer Bank Holiday
    "2025-12-25", // Christmas Day
    "2025-12-26", // Boxing Day

    // 2026
    "2026-01-01", // New Year's Day
    "2026-04-03", // Good Friday
    "2026-04-06", // Easter Monday
    "2026-05-04", // Early May Bank Holiday
    "2026-05-25", // Spring Bank Holiday
    "2026-08-31", // Summer Bank Holiday
    "2026-12-25", // Christmas Day
    "2026-12-28", // Boxing Day (substitute day)

    // 2027
    "2027-01-01", // New Year's Day
    "2027-03-26", // Good Friday
    "2027-03-29", // Easter Monday
    "2027-05-03", // Early May Bank Holiday
    "2027-05-31", // Spring Bank Holiday
    "2027-08-30", // Summer Bank Holiday
    "2027-12-27", // Christmas Day (substitute day)
    "2027-12-28", // Boxing Day (substitute day)
  ];

  const isDateBankHoliday = (date) => {
    const formattedDate = date.toISOString().split('T')[0];
    return ukBankHolidays.includes(formattedDate);
  };

  const getNextDeliveryDate = () => {
    const now = new Date();
    const currentHour = now.getHours();
    let deliveryDate = new Date();

    // If it's after 1 PM, start from day after tomorrow
    // If it's before 1 PM, start from tomorrow
    deliveryDate.setDate(deliveryDate.getDate() + (currentHour >= 13 ? 2 : 1));

    // Keep incrementing the date until we find a valid delivery day
    while (
      deliveryDate.getDay() === 0 || // Sunday
      isDateBankHoliday(deliveryDate)
    ) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    return deliveryDate;
  };

  const formatDeliveryDate = (date) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const dayName = days[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = months[date.getMonth()];
    
    const suffix = (day) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    return `${dayName} ${dayOfMonth}${suffix(dayOfMonth)} ${month}`;
  };

  const updateButtonVisibility = () => {
    const availableServices = JSON.parse(localStorage.getItem('available_services')) || [];
    document.querySelectorAll('.product-service-options').forEach(checkbox => {
      const serviceRow = checkbox.closest('.product-services-row');
      if (!serviceRow) return;

      const serviceSku = serviceRow.dataset.serviceSku;
      const location = serviceRow.dataset.location;
      
      // National services are always available
      const isNationalService = location === 'National';
      const isServiceAvailable = isNationalService || availableServices.includes(serviceSku);
      
      checkbox.disabled = !isServiceAvailable;
      if (!isServiceAvailable && checkbox.checked) {
        checkbox.checked = false;
        handleServiceUncheck(checkbox);
      }
    });
  };

  const handleServiceUncheck = (checkbox) => {
    const parentProductId = checkbox.dataset.parentProductId;
    const serviceId = checkbox.dataset.serviceId;
    
    let storedData = JSON.parse(localStorage.getItem('product_services')) || {};
    if (storedData[parentProductId]) {
      storedData[parentProductId].selected_product_services = 
        storedData[parentProductId].selected_product_services.filter(id => id !== serviceId);
      
      if (storedData[parentProductId].selected_product_services.length === 0) {
        delete storedData[parentProductId];
      }
      
      localStorage.setItem('product_services', JSON.stringify(storedData));
    }
  };

  const updateDynamicContent = () => {
    const availableServices = JSON.parse(localStorage.getItem('available_services')) || [];
    const deliveryAvailable = localStorage.getItem('delivery_available');
    const postcodeStockMessages = document.querySelectorAll('.postcode-stock-message');
    const datesArray = JSON.parse(localStorage.getItem('delivery_dates')) || [];
    
    const nextDeliveryDate = getNextDeliveryDate();
    const formattedDate = formatDeliveryDate(nextDeliveryDate);
    
    postcodeStockMessages.forEach(message => {
      const deliveryIcon = message.previousElementSibling;
      
      if (datesArray.length === 0 && deliveryAvailable === 'false') {
        message.textContent = "Sorry we don't deliver to this area";
        if (deliveryIcon) {
          deliveryIcon.classList.remove('badge-green');
        //   deliveryIcon.classList.add('badge-red');
          deliveryIcon.setAttribute('icon', 'solar:close-circle-bold-duotone');
        }
      } else if (deliveryAvailable === 'true') {
        message.textContent = `Delivery from ${formattedDate}`;
        if (deliveryIcon) {
          deliveryIcon.classList.remove('badge-red');
          deliveryIcon.classList.add('badge-green');
          deliveryIcon.setAttribute('icon', 'solar:check-circle-bold-duotone');
        }
      } else if (deliveryAvailable === null) {
        message.textContent = `Delivery from ${formattedDate}`;
        if (deliveryIcon) {
          deliveryIcon.classList.remove('badge-red');
          deliveryIcon.classList.add('badge-green');
          deliveryIcon.setAttribute('icon', 'solar:check-circle-bold-duotone');
        }
      } else {
        message.textContent = 'Available - view options at checkout';
        if (deliveryIcon) {
          deliveryIcon.classList.remove('badge-red');
          deliveryIcon.classList.add('badge-green');
          deliveryIcon.setAttribute('icon', 'solar:check-circle-bold-duotone');
        }
      }
    });

    updateButtonVisibility();
    updateCartServiceButtons();
  };

  const updateCartServiceButtons = () => {
    const availableServices = JSON.parse(localStorage.getItem('available_services')) || [];
    
    document.querySelectorAll('.cart-item-service').forEach(serviceRow => {
      const addButton = serviceRow.querySelector('.add-service');
      const localMessage = serviceRow.querySelector('.local-message');
      const location = serviceRow.getAttribute('data-location');
      const serviceSku = serviceRow.getAttribute('data-service-sku');
      
      // National services are always available (case insensitive check)
      const isNationalService = location && location.toLowerCase() === 'national';
      const isServiceAvailable = isNationalService || availableServices.includes(serviceSku);
      
      if (addButton) {
        addButton.disabled = !isServiceAvailable;
        addButton.textContent = isServiceAvailable ? "Add +" : "Not available";
        addButton.classList.toggle('disabled-button', !isServiceAvailable);
      }
      
      if (localMessage) {
        localMessage.style.display = isServiceAvailable ? 'none' : 'block';
      }
    });
  };

  const loadPostcode = () => {
    const existingPostcode = localStorage.getItem('user_postcode');
    if (existingPostcode) {
      postcodeInputs.forEach(input => {
        input.value = existingPostcode;
      });
      postcodeReference.forEach(reference => {
        reference.textContent = existingPostcode.toUpperCase();
      });
    }
  };

  const updatePostcode = (postcode) => {
    if (postcode.length === 0) {
      localStorage.removeItem('user_postcode');
      localStorage.removeItem('available_services');
      localStorage.removeItem('delivery_available');
      localStorage.removeItem('delivery_dates');

      postcodeInputs.forEach(input => {
        input.value = '';
      });
      postcodeReference.forEach(reference => {
        reference.textContent = 'Enter postcode';
      });

      updateDynamicContent();
      return;
    }

    if (postcode.length >= 4) {
      localStorage.setItem('user_postcode', postcode.toUpperCase());

      fetch(`https://awodeliverydates-production.up.railway.app/delivery-options?postcode=${postcode}`)
        .then(response => response.json())
        .then(data => {
          if (data) {
            const hasDeliveryDates = (data.dates || []).length > 0;
            localStorage.setItem('available_services', JSON.stringify(data.available_services || []));
            localStorage.setItem('delivery_available', hasDeliveryDates ? 'true' : 'false');
            localStorage.setItem('delivery_dates', JSON.stringify(data.dates || []));

            document.dispatchEvent(new CustomEvent('postcodeUpdated', { 
              detail: { 
                postcode,
                availableServices: data.available_services || []
              } 
            }));
            
            updateDynamicContent();
          }
        })
        .catch(error => {
          console.error('Error fetching delivery dates:', error);
        });

      postcodeInputs.forEach(input => {
        input.value = postcode;
      });

      postcodeReference.forEach(reference => {
        reference.textContent = postcode.toUpperCase();
      });

      postcodeStatuses.forEach(status => {
        status.style.display = 'block';
        setTimeout(() => {
          status.style.display = 'none';
        }, 2000);
      });
    }
  };

  const handleEnterKeyEvent = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      updatePostcode(event.target.value.trim());
      event.target.blur();
    }
  };

  postcodeInputs.forEach(input => {
    input.typingTimer = null;
    input.addEventListener('blur', () => updatePostcode(input.value.trim()));
    input.addEventListener('keydown', handleEnterKeyEvent);
    input.addEventListener('input', () => {
      clearTimeout(input.typingTimer);
      input.typingTimer = setTimeout(() => updatePostcode(input.value.trim()), 500);
    });
  });

  loadPostcode();
  updateDynamicContent();

  // Shared delivery functions
  const getDeliveryOptions = async (postcode, services = []) => {
    const url = new URL('https://awodeliverydates-production.up.railway.app/delivery-options');
    url.searchParams.append('postcode', postcode);

    // Get SKUs only from added services
    const addedServices = [];
    document.querySelectorAll('[data-added-service-sku]').forEach(serviceDetail => {
      const serviceSku = serviceDetail.getAttribute('data-added-service-sku');
      if (serviceSku) {
        addedServices.push(serviceSku);
      }
    });

    // Check for free delivery tags across all products in cart
    const hasAwFreeDelivery = Object.values(productTags).some(product => 
      (product.tags || []).some(tag => 
        tag.toLowerCase().includes('free aw delivery')
      )
    );

    const hasArrowFreeDelivery = Object.values(productTags).some(product => 
      (product.tags || []).some(tag => 
        tag.toLowerCase().includes('free arrow delivery')
      )
    );

    if (isDevMode) console.log('Free delivery status:', { hasAwFreeDelivery, hasArrowFreeDelivery });

    // Add free delivery parameters if applicable
    if (hasAwFreeDelivery) {
      url.searchParams.append('freeAwDelivery', 'true');
    }
    if (hasArrowFreeDelivery) {
      url.searchParams.append('freeArrowXlDelivery', 'true');
    }

    if (isDevMode) console.log('Found added service SKUs:', addedServices);
    if (isDevMode) console.log('Additional services passed:', services);

    // Combine added services with passed services (like 2MAN)
    const allServices = [...new Set([...services, ...addedServices])];
    if (isDevMode) console.log('Combined unique services:', allServices);
    
    if (allServices.length > 0) {
      url.searchParams.append('services', allServices.join(','));
    }
    
    if (isDevMode) console.log('Final API URL:', url.toString());
    
    try {
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching delivery options:', error);
      return null;
    }
  };

  const getCollectionDates = async () => {
    try {
      if (isDevMode) console.log('Requesting collection dates');
      const response = await fetch(`https://awodeliverydates-production.up.railway.app/getcollectiondates`);
      const data = await response.json();
      if (isDevMode) console.log('Collection dates response:', data);
      return data;
    } catch (error) {
      console.error('Error fetching collection dates:', error);
      return null;
    }
  };

  const hasServicesInCart = (cartData) => {
    return cartData.items.some(item => {
      const tags = productTags[item.product_id]?.tags || [];
      return tags.some(tag => 
        tag.toLowerCase().includes('installation') || 
        tag.toLowerCase().includes('appliance removal')
      );
    });
  };

  const hasLargeApplianceInCart = (cartData) => {
    return cartData.items.some(item => {
      const productInfo = productTags[item.product_id] || {};
      const productType = (productInfo.type || '').toLowerCase();
      return productType.includes('american fridge freezer') || 
             productType.includes('range cooker');
    });
  };

  // Export functions for use in delivery-choices.liquid
  window.awoPostcode = {
    getDeliveryOptions,
    getCollectionDates,
    hasServicesInCart,
    hasLargeApplianceInCart
  };
});
